/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  formatRange
 */

export function formatRange(min: null | undefined, max: null | undefined): null
export function formatRange(min: number, max: number): `${number}` | `${number}–${number}`
export function formatRange(min: number, max: null | undefined): `${number}+`
export function formatRange(min: null | undefined, max: number): `up to ${number}`
export function formatRange(
  min: number | null | undefined,
  max: number | null | undefined
): `${number}+` | `up to ${number}` | `${number}` | `${number}–${number}` | null
export function formatRange(
  min: number | null | undefined,
  max: number | null | undefined
): `${number}+` | `up to ${number}` | `${number}` | `${number}–${number}` | null {
  if (min != null && max != null && min > max) {
    return formatRange(max, min)
  }
  if (max == null) {
    if (min == null) {
      return null
    }
    return `${min}+`
  } else if (min == null) {
    return `up to ${max}`
  }
  return min === max ? `${min}` : `${min}–${max}`
}
